<template>
  <div class="loading" v-if="loadingData">
    <div class="loadingSpinnerContainer">
      {{textDisplay}}
      <div class="loadingSpinner"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UiLoadingData',
    props: ['loadingData', 'text'],
    data () {
      return {
        checked: false,
        textDisplay: 'טוען מידע... אנא המתן'
      }
    },
    methods: {},
    created () {
      if (this.text) this.textDisplay = this.text;
    }
  }
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";

  .loading {
    text-align: center;
    font-size: 22px;
    margin: 115px auto;
    width: 280px;
    display: block;
    text-shadow: 1px 1px 0px rgba(15, 15, 15, .15), -1px -1px 0px #fff;
    color: @grey-dark;
  }

  .loadingSpinnerContainer {
    position: relative;
  }
  .loadingSpinner {
    position: absolute;
    left: 15px;
    top: 5px;
    font-size: 10px;
    text-indent: -9999em;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: transparent;
    background: -moz-linear-gradient(left, @blue-dark 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, @blue-dark 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, @blue-dark 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, @blue-dark 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, @blue-dark 10%, rgba(255, 255, 255, 0) 42%);
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loadingSpinner:before {
    width: 50%;
    height: 50%;
    background: @blue-dark;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  .loadingSpinner:after {
    background: #f4f4f4;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/uiLoadingData.vue